import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ConfirmReleaseSDSNextDayDeliveryDialog extends Component {
    constructor(props) {
        super(props);
		this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ConfirmReleaseSDSNextDayDeliveryDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
	handleYes(event) {
		this.props.updateOrderStatus("Create", 'showConfirmReleaseSDSNextDayDeliveryDialog');
	}
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeDeliveryMethodYESOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Confirm Booking</h2>
                    <p>All orders requesting <strong>SDS Next Day Delivery (M038 - Hot Shot)</strong> must be released prior to 12:00 p.m. local time to receive next business day delivery.</p>
                    <p>Do you want to continue?</p>
                    <div className="noButtonContainer">
                        <a onClick={this.closeDialog.bind(this)} href="" className="noButton blueButton">No</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.handleYes.bind(this)}>Yes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ConfirmReleaseSDSNextDayDeliveryDialog = connect(mapStateToProps)(ConfirmReleaseSDSNextDayDeliveryDialog);
export default ConfirmReleaseSDSNextDayDeliveryDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmReleaseSDSNextDayDeliveryDialog.js